import * as React from "react";
import { connect } from "react-redux";

import { MANAGEMENT_CONSOLE_LICENSE } from "components/licenses/bundles";
import InstallBmpOp from "components/products/bmpop-home-page/InstallBmpOp";
import LaunchBmpOp from "components/products/bmpop-home-page/LaunchBmpOp";
import SystemPreparation from "components/products/bmpop-home-page/SystemPreparation";
import { LicenseData } from "domain/licenses";
import {
    BmpOpOnboardingSteps,
    checkIfMenuExpanded,
    checkIfStepIsClickable,
    getStepIndexForBmpOp,
    isStepCompleted,
} from "domain/onboardings";
import { OnboardingImage, Versions } from "domain/softwarePackages";
import { Onboarding } from "services/onboardings/OnboardingsService";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

const connector = connect(mapState);

interface Props {
    lastCompletedStepIndex: number;
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    images: OnboardingImage[];
    saveOnboardingStep: (onboarding: Onboarding) => void;
    stepInProgressIndex: number;
    saveStepInProgressIndex: (index: number) => void;
}

const BmpOpSteps = (props: Props): JSX.Element => {
    const getStepIndex = (step: BmpOpOnboardingSteps | undefined) => {
        return getStepIndexForBmpOp(step);
    };

    function fetchLinkToDownload(): OnboardingImage | undefined {
        const packageToDownload = props.images.find((each) => each.licenseId.toString() === MANAGEMENT_CONSOLE_LICENSE);
        if (packageToDownload) {
            return packageToDownload;
        }
        return undefined;
    }

    return (
        <>
            <SystemPreparation
                stepIndex={getStepIndex(BmpOpOnboardingSteps.STEP_SYSTEM_PREPARATION)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BmpOpOnboardingSteps.STEP_SYSTEM_PREPARATION),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BmpOpOnboardingSteps.STEP_SYSTEM_PREPARATION),
                    props.lastCompletedStepIndex
                )}
                stepActive={true}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BmpOpOnboardingSteps.STEP_SYSTEM_PREPARATION),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
            />
            <InstallBmpOp
                stepIndex={getStepIndex(BmpOpOnboardingSteps.STEP_BMPOP_INSTALLATION)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BmpOpOnboardingSteps.STEP_BMPOP_INSTALLATION),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BmpOpOnboardingSteps.STEP_BMPOP_INSTALLATION),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BmpOpOnboardingSteps.STEP_BMPOP_INSTALLATION),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
                package={fetchLinkToDownload()}
            />
            <LaunchBmpOp
                stepIndex={getStepIndex(BmpOpOnboardingSteps.STEP_LAUNCHING_BMPOP)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BmpOpOnboardingSteps.STEP_LAUNCHING_BMPOP),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BmpOpOnboardingSteps.STEP_LAUNCHING_BMPOP),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BmpOpOnboardingSteps.STEP_LAUNCHING_BMPOP),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
            />
        </>
    );
};

export default connector(BmpOpSteps);
